import axios from 'axios';

export class OrgDirApi {
  static ChangeCurrentOrganization(baseUrl: string, token: string, organizationId: string) {
    return axios.patch(`${baseUrl}/api/v3/user/current/current-organization/${organizationId}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  static GetPendingConsentForService(baseUrl: string, token: string, serviceId: string) {
    return axios.get(`${baseUrl}/api/v3/consent/currentPending?serviceId=${serviceId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
